import './typography.scss';

import React from 'react';

const TextComponent = ({ children, className = '', ...rest }) => {
	const [headerStyle = 'h1', fontWeightStyle = 'regular'] = Object.keys(rest);
	return (
		<span {...rest} className={`edenredTypo ${headerStyle} ${fontWeightStyle} ${className} `}>
			{children}
		</span>
	);
};

export default TextComponent;
